import {
  CircularProgress,
  Divider,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
} from '@chakra-ui/react';
import ContractModalHeader from '../../molecules/ContractModalHeader';
import ContractReviewStep from '../../organisms/ContractReviewStep';
import ContractTypeOptions from '../../organisms/ContractTypeOptions';
import PaymentStep from '../../organisms/Payment';
import ServicesStep from '../../organisms/ServicesStep';
import { useCreateContractModalContext } from './ModalContext';

interface CreateContractModalProps {
  isOpen: boolean;
  onClose(): void;
}

const CreateContractModal: React.FC<CreateContractModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { step, loading, contract, handleSubmit } =
    useCreateContractModalContext();

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="xl">
      <DrawerOverlay />

      <DrawerContent
        pos="relative"
        display="flex"
        flexDirection="column"
        overflow="hidden"
      >
        <DrawerCloseButton />
        {contract ? (
          <DrawerHeader>
            Adicionar serviços
            <Divider my="1rem" />
          </DrawerHeader>
        ) : (
          <ContractModalHeader />
        )}

        {!contract && step === 0 && <ContractTypeOptions onClose={onClose} />}
        {step === 1 && (
          <ServicesStep
            onClose={onClose}
            onNext={contract ? handleSubmit : undefined}
          />
        )}
        {!contract && step === 2 && <PaymentStep onClose={onClose} />}
        {!contract && step === 3 && <ContractReviewStep onClose={onClose} />}

        {loading && (
          <Flex
            pos="absolute"
            top="0"
            left="0"
            w="100%"
            h="100%"
            bg="gray.100"
            zIndex="1"
            align="center"
            justify="center"
          >
            <CircularProgress isIndeterminate color="yooga.400" />
          </Flex>
        )}
      </DrawerContent>
    </Drawer>
  );
};

export default CreateContractModal;
